var map = {
	"./Frame.svg": 10,
	"./about-loyalty.svg": 11,
	"./active-arrow.svg": 12,
	"./add_photo.svg": 13,
	"./affiliatedCompanies.svg": 14,
	"./api-key-created.svg": 15,
	"./api-key.svg": 16,
	"./arrow-asc-sort.svg": 17,
	"./arrow-back.svg": 18,
	"./arrow-bottom-dark.svg": 19,
	"./arrow-bottom.svg": 20,
	"./arrow-desc-sort.svg": 21,
	"./arrow-go.svg": 22,
	"./arrow-graph-down.svg": 23,
	"./arrow-graph-up.svg": 24,
	"./arrow-in-screen.svg": 25,
	"./arrow-left.svg": 26,
	"./arrow-no-sort.svg": 27,
	"./arrow-right.svg": 28,
	"./arrow-top-dark.svg": 29,
	"./arrow-vertical-dark.svg": 30,
	"./arrow-vertical.svg": 31,
	"./attach.svg": 32,
	"./bell.svg": 33,
	"./boxes.svg": 34,
	"./bulb.svg": 35,
	"./calculator-light.svg": 36,
	"./cargo-tarif.svg": 37,
	"./cart.svg": 38,
	"./check-read.svg": 39,
	"./checkmark.svg": 40,
	"./clip.svg": 41,
	"./contacts-menu.svg": 42,
	"./contract-bird-circle.svg": 43,
	"./contract-minus-circle.svg": 44,
	"./contract-warning-circle.svg": 45,
	"./contract-x-circle.svg": 46,
	"./contract_modal.svg": 47,
	"./contracts.svg": 48,
	"./copy.svg": 49,
	"./cross.svg": 50,
	"./customer.svg": 51,
	"./data-delivery.svg": 52,
	"./data-fence.svg": 53,
	"./data-info.svg": 54,
	"./data-receipt.svg": 55,
	"./delete.svg": 56,
	"./delivery-car.svg": 57,
	"./delivery-logo.svg": 58,
	"./delivery.svg": 59,
	"./disabled-arrow.svg": 60,
	"./document.svg": 61,
	"./documents_and_files.svg": 62,
	"./done_active-1.svg": 63,
	"./done_active.svg": 64,
	"./download-analitics.svg": 65,
	"./download.svg": 66,
	"./drag.svg": 67,
	"./dropzone-document.svg": 68,
	"./dropzone-pin.svg": 69,
	"./edit-tarif.svg": 70,
	"./edit_small.svg": 71,
	"./email.svg": 72,
	"./employees.svg": 73,
	"./eye-invisible.svg": 74,
	"./eye-svg.svg": 75,
	"./filter.svg": 76,
	"./gear-in-screen.svg": 77,
	"./generated-receipt.svg": 78,
	"./gold-ring.svg": 79,
	"./graphic-analitics.svg": 80,
	"./head-bg.svg": 81,
	"./home-auto.svg": 82,
	"./home-cod.svg": 83,
	"./home-dispatch.svg": 84,
	"./home-invoices.svg": 85,
	"./home-orders.svg": 86,
	"./home-pay.svg": 87,
	"./home-receipt.svg": 88,
	"./home-receiving.svg": 89,
	"./home-ttn.svg": 90,
	"./icon-cards.svg": 91,
	"./icon-date.svg": 92,
	"./icon-filter.svg": 93,
	"./icon-stats.svg": 94,
	"./icon-table-max.svg": 95,
	"./icon-table-min.svg": 96,
	"./icon-table.svg": 97,
	"./icon-time.svg": 98,
	"./info.svg": 99,
	"./investigation.svg": 100,
	"./invoices.svg": 101,
	"./key.svg": 102,
	"./location.svg": 103,
	"./lock.svg": 104,
	"./loyalty.svg": 105,
	"./manager-analitics.svg": 106,
	"./minus.svg": 107,
	"./new-invoice-icon.svg": 108,
	"./notification.svg": 109,
	"./order-car-reverse.svg": 110,
	"./order-car.svg": 111,
	"./owner.svg": 112,
	"./pallet-tarif.svg": 113,
	"./parcel-route.svg": 114,
	"./payer-en.svg": 115,
	"./payer-ru.svg": 116,
	"./payer-uk.svg": 117,
	"./payer.svg": 118,
	"./payment-card.svg": 119,
	"./payment-cash.svg": 120,
	"./pdf.svg": 121,
	"./person.svg": 122,
	"./phone.svg": 123,
	"./plus-circle.svg": 124,
	"./plus.svg": 125,
	"./posilka-tarif.svg": 126,
	"./print.svg": 127,
	"./promocode.svg": 128,
	"./receipt.svg": 129,
	"./reciever-en.svg": 130,
	"./reciever-ru.svg": 131,
	"./reciever-uk.svg": 132,
	"./reciever.svg": 133,
	"./rubrics-0-0.svg": 134,
	"./rubrics-0-1.svg": 135,
	"./rubrics-0-2.svg": 136,
	"./rubrics-0-3.svg": 137,
	"./rubrics-0-4.svg": 138,
	"./rubrics-0-5.svg": 139,
	"./rubrics-0-6.svg": 140,
	"./rubrics-1-0.svg": 141,
	"./rubrics-1-1.svg": 142,
	"./rubrics-1-2.svg": 143,
	"./rubrics-1-3.svg": 144,
	"./rubrics-1-4.svg": 145,
	"./rubrics-1-5.svg": 146,
	"./rubrics-1-6.svg": 147,
	"./search.svg": 148,
	"./sender-en.svg": 149,
	"./sender-ru.svg": 150,
	"./sender-uk.svg": 151,
	"./sender.svg": 152,
	"./settings.svg": 153,
	"./speedometer-arrow.svg": 154,
	"./speedometer-bg.svg": 155,
	"./speedometer-separator.svg": 156,
	"./star-gray.svg": 157,
	"./star-orange.svg": 158,
	"./status-icon-four.svg": 159,
	"./status-icon-one.svg": 160,
	"./status-icon-three.svg": 161,
	"./status-icon-two.svg": 162,
	"./status-icon-zero.svg": 163,
	"./step-bg.svg": 164,
	"./subsidiaries.svg": 165,
	"./tarif-analitics.svg": 166,
	"./tg_Icon.svg": 167,
	"./thanks.svg": 168,
	"./ticket-payment-bird.svg": 169,
	"./user.svg": 170,
	"./vchasno.svg": 171,
	"./warehouse0.svg": 172,
	"./warehouse1.svg": 173,
	"./warehouse3.svg": 174
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9;